import { motion } from "framer-motion";

/**
 * A subtle horizontal gold swoosh that echoes the wave in the brand logo card.
 * Placed between light sections to give the page a "flowing paper" rhythm.
 * The line draws itself when it scrolls into view.
 */
export default function WaveDivider({ variant = "cream", flip = false }) {
  const bg = variant === "cream" ? "#eae7de" : variant === "sand" ? "#ded9cb" : "transparent";
  return (
    <div
      data-testid={`wave-divider-${variant}${flip ? "-flip" : ""}`}
      className="relative py-6 overflow-hidden"
      style={{ backgroundColor: bg }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1400 60"
        className={`w-full h-10 lg:h-12 block ${flip ? "scale-y-[-1]" : ""}`}
        preserveAspectRatio="none"
      >
        <motion.path
          d="M 0 30 Q 350 5 700 30 T 1400 30"
          fill="none"
          stroke="#c9a961"
          strokeWidth="1.5"
          strokeLinecap="round"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true, margin: "-30px" }}
          transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        />
        <motion.path
          d="M 0 34 Q 350 10 700 34 T 1400 34"
          fill="none"
          stroke="#c9a961"
          strokeWidth="0.8"
          strokeLinecap="round"
          opacity="0.4"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true, margin: "-30px" }}
          transition={{ duration: 1.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        />
      </svg>
    </div>
  );
}
